import React, { useState } from "react"
import { Container, Form} from "reactstrap"
import { useFormik } from "formik"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../components/ResultHandler"
import FormButtonHandler from "../../../components/FormButtonHandler"
import { useResponse } from "../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../hooks/useGetInstence"
import { LEAVES_REQUIRED_FIELDS } from "./CONSTANT"
import * as Yup from "yup"
import { editLeave, getLeave } from "../../../api/leaves"
import LeavesForm from "./LeavesForm"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

LEAVES_REQUIRED_FIELDS.forEach((f) => {
    initialValues[f.key] = TYPES[f.type] || "";
    
    if (f.type == "file") {
        FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
            "This Field Is Required"
        );
    } else if (f.type == "select" && f.isMulti) {
        FIELDS_VALIDATION[f.key] = Yup.array();
    } else {
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
    }
});

const EditLeave = () => {
    let navigate = useHistory()
    const { t } = useTranslation()
    const {id: leaveId} = useParams()
    const [editedLeave, setEditedLeave] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getLeave,
        leaveId,
        response => {
            setEditedLeave({...response.data.holiday})
        }
    )

    const { setData, loading, error, success } = useResponse(editLeave, () => {
        navigate.goBack()
    })
    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {...editedLeave},
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: (data) => {
            setData({ type: "edit", id: leaveId, data })
        },
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Leaves")}
                        breadcrumbItem={t("btns.Edit") + " " + t("Leave")}
                    />
                    
                        {editedLeave && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <LeavesForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>
                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditLeave